import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const OrderRequestSlice = createSlice({
    name: "orderRequest",
    initialState,
    reducers: {
        orderRequest(state) {
            state.loading = true;
        },
        orderRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        orderRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        orderStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    orderRequest,
    orderRequestSuccess,
    orderRequestError,
    orderStateReset
} = OrderRequestSlice.actions;

export default OrderRequestSlice.reducer;
